var globalFunctions = require('./globalFunctions.js');

module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title-long">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>GG&-2.5</li> '+
                            '<li>GG&+2.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>NG&-2.5</li> '+
                            '<li>NG&+2.5</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title-long">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="GG&-2.5" data-betCode="251" class="bet-choose" data-odd="'+quotes.Under25_GG+'">'+globalFunctions.checkQuotes(quotes.Under25_GG)+'</li> '+
                                '<li data-betType="GG&+2.5" data-betCode="252" class="bet-choose" data-odd="'+quotes.Over25_GG+'">'+globalFunctions.checkQuotes(quotes.Over25_GG)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="NG&-2.5" data-betCode="261" class="bet-choose" data-odd="'+quotes.Under25_NG+'">'+globalFunctions.checkQuotes(quotes.Under25_NG)+'</li> '+
                                '<li data-betType="NG&+2.5" data-betCode="262" class="bet-choose" data-odd="'+quotes.Over25_NG+'">'+globalFunctions.checkQuotes(quotes.Over25_NG)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/gg_ng_and_under_over.js
// module id = 2018
// module chunks = 4